module.exports = __webpack_public_path__ + "static/media/icon-produtos.f4910e9c.svg";